import React, { useState } from "react"
import styled, { createGlobalStyle } from "styled-components"
import PropTypes from "prop-types"
import { useIntl } from "gatsby-plugin-react-intl"

import Lightbox from "./Lightbox"
import { TextButton } from "./Button"
import Search from "./Search"

import { media } from "../styles"

const SearchWrapper = styled.div`
  @media ${media.xl} {
    padding: 0 80px 20px;
  }
`

const OverlayStyle = createGlobalStyle`
  .searchOverlay {
    [data-reach-dialog-content] {
      width: 100vw;

      @media ${media.sm} {
        width: 80vw;
      }
    }

    [data-reach-dialog-content] {
      @media ${media.smDown} {
        padding-left: 15px;
        padding-right: 15px;
      }
    }
  }
`

const SearchOverlay = ({ indexUrl, storeUrl, button }) => {
  const [showDialog, setShowDialog] = useState(false)
  const intl = useIntl()

  const openLightbox = (e) => {
    e.preventDefault()
    setShowDialog(true)
  }
  const closeLightbox = () => setShowDialog(false)

  return (
    <>
      <OverlayStyle />
      <TextButton
        aria-label={intl.formatMessage({ id: "search.label" })}
        onClick={(e) => openLightbox(e)}
      >
        {button}
      </TextButton>
      <Lightbox
        ariaLabel={intl.formatMessage({ id: "search.label" })}
        close={closeLightbox}
        show={showDialog}
        className="searchOverlay"
      >
        <SearchWrapper>
          <Search
            indexUrl={indexUrl}
            storeUrl={storeUrl}
            supportUrlQuery={true}
          />
        </SearchWrapper>
      </Lightbox>
    </>
  )
}

SearchOverlay.propTypes = {
  indexUrl: PropTypes.string.isRequired,
  storeUrl: PropTypes.string.isRequired,
  button: PropTypes.node.isRequired,
}

export default SearchOverlay
